import { motion } from "framer-motion";

const headerAnimation = {
  initial: { opacity: 0, y: -20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  transition: { duration: 0.3 },
};

function Header({ t }) {

  return (
    <motion.div
      {...headerAnimation}
      className="text-[#246CE2] text-[3.3vh] font-sans font-bold ml-[2vw] mt-2 mb-[1vh]"
    >
      {t("editDoc.title")}
    </motion.div>
  );
}

export default Header;